export const selectedGroups = (state) => state.groups.selectedGroups;
export const isAllGrpSelected = (state) => state.groups.isAllGrpSelected;
